import { HistoryElement } from "@/types";
import { getData } from "./axios-service";

function modelMapper(inputHistoryElement: any): HistoryElement {
    return {
        id: inputHistoryElement.id,
        name: inputHistoryElement.laverieName ?? inputHistoryElement.storageDepotName,
        inDate: inputHistoryElement.inDate,
        outDate: inputHistoryElement.outDate
    };
}

export function modelMapperArray(inputArray: any[]): HistoryElement[] {
    return inputArray.map(modelMapper);
}

export async function getHistoryElementsByProduct(productId: string): Promise<HistoryElement[]> {
    const historyElements = await getData<HistoryElement[]>("products/" + productId + "/history-elements");
    return modelMapperArray(historyElements ?? []);
}